import React from "react";
import "./articledetail.scss";
import Globals from "../../api";
import { Suspense, lazy } from "react";
import Article_bottom_text from '../ad-units/article_bottom_text';
import ROS_Left_336_280 from '../ad-units/Ros_left_300_250';
import ROS_Top_336_280 from '../ad-units/ros_top_300_250';
import Article_Middle_728_90 from '../ad-units/article_middle_728_90';
import ROS_Middle_Center_336_280 from '../ad-units/ros_middle_center_728_90';
import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';
import ReactHtmlParser from "react-html-parser";
import RelatedArticle from "../../components/RelatedArticle/relatedarticle";
import Rightbar from "../../components/Rightbar/Rightbar";
import { Helmet } from "react-helmet";
import ImageConvertionDefault from "../../config";
//import $ from 'jquery'; 
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
export default class ArticleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Articledata: [],
      videos: [],
      meta: [],
      title: [],
      meta_keywords: [],
      meta_description: [],
      AdUnits : [],
      Ogimage :[],
      Domainurl : [],
      Horoscope :[],
      Rightbar : [], 
      googleAds : [],
      CricketData : [],
      IsVideoArticle : [],
      VideoArticleUrl :[],
      AdultContent :false
    };
  }
  getHoroscope() {
    // console.log('api at header' + Globals.language_based_api);
        const url= Globals.language_based_api+'%2Fhome-page';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
          
            this.setState({
              Horoscope : data.Contents
            })
        }) 
      }
   getGoogleAds(){
             const url= Globals.AdConfig;
              fetch(url)
                .then((res) => res.json())
                .then((data) => {
                let URI = window.location.pathname;
                const url1 = Globals.language_based_api + URI;
                  fetch(url1)
                .then((res1) => res1.json())
                  .then((data1) => {
                   this.setState({
                    AdultContent : data1.AdultContent
                  });
                  console.log("adult content ",data1.AdultContent)
                 if(data1.AdultContent){
                    this.setState({
                        googleAds : data.AdContents[0].SLROS
                      })
                    } else{
                this.setState({
                   googleAds : data.AdContents[0].ROS
                })
               }
              });
             }) 
                
     }
  getAds(){
    const url = Globals.Ad_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          AdUnits: data.AdContents[0].header_sponsor_logo,
        });
      });
  }
  getRightbar(){
    let URI = window.location.pathname.split("/");
    const url = Globals.Rightbar_api+ "/" + URI[2];
    //const url = Globals.Rightbar_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          Rightbar: data.Contents[0]
        });
      });
  }

  getCricketUpdate(){
    const url= Globals.Cricket_update_api ;
    //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          CricketData : data.CurrentMatches
          
        })
    })   
    //console.log("url ",url)
  }
  componentDidMount() {
    let URI = window.location.pathname;
    const url = Globals.language_based_api + URI;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {

        var VideoArticleData = data.Contents.filter(e=>e.Type === "Article")[0].VideoOnTop;
        var VideoArticleUrl = data.Contents.filter(e=>e.Type === "Article")[0].VideoUrl;

        this.setState({
          IsVideoArticle : VideoArticleData,
          VideoArticleUrl :VideoArticleUrl,
          Articledata: data.Contents,
          meta: data.Meta,
          title: data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content,
          Ogimage: data.Contents[2].Thumbnail,
          Domainurl : data.Contents[2].Url,
          AdultContent : data.AdultContent
        });
              
      if (data.AdultContent) {
        const mgidScript = document.getElementById("en_mgid");
        const aniviewScript = document.getElementById("AV611661025c3adf4d362a1e70");
        const momagic_script = document.getElementById("interactive_js_adcode");
        const andbeyond_script = document.getElementById("andbeyond_script");
        const vuukle_script = document.getElementById("vuukle_script");
        const vuukle_comments = document.getElementById("vuukle-comments");
        const momagic_sc= document.getElementById("momagic_script");
         const mgidWidget = document.querySelector('div[data-type="_mgwidget"][data-widget-id="1630949"]');
          if (mgidWidget) {
            mgidWidget.remove();
          }
          if (momagic_sc) {
            momagic_sc.remove();
          }
           if (aniviewScript) {
            aniviewScript.remove();
          }
         setTimeout(() => {
                const aniviewScript = document.querySelector('script[src="https://player.aniview.com/script/webm/ads.js"]');
                if (aniviewScript) {
                  aniviewScript.remove();
                  } 
                  if (momagic_script) {
                  momagic_script.remove();
                 }
                 const avScript = Array.from(document.querySelectorAll('script')).find(
                  (script) =>
                    script.src &&
                    script.src.includes("player.aniview.com/script/6.1/AVmanager.js")
                 );
                if (avScript) {
                 avScript.remove();
                } 
                if (mgidScript) {
                  mgidScript.remove();
                }
                if (aniviewScript) {
                  aniviewScript.remove();
                }
                if (momagic_script) {
                  momagic_script.remove();
                }
                if (andbeyond_script) {
                  andbeyond_script.remove();
                }
                  if (vuukle_script) {
                  vuukle_script.remove();
                }
                if (vuukle_comments) {
                  vuukle_comments.remove();
                }
                 const vuukleQuiz = document.getElementById("vuukle-quiz-container");
                 if (vuukleQuiz) {
                vuukleQuiz.remove();
                 }
            }, 2000); 
               const aniPlayerDiv = document.getElementById('aniview_player');
                if (aniPlayerDiv) {
                  aniPlayerDiv.remove();
              }
               const interactive_js_adcode = document.getElementById("interactive_js_adcode");
              if (interactive_js_adcode) {
                interactive_js_adcode.remove();
              }
              const vuukleQuiz = document.getElementById("vuukle-quiz-container");
              if (vuukleQuiz) {
                vuukleQuiz.remove();
              }
              const mgidWidget1 = document.querySelector('div[data-type="_mgwidget"][data-widget-id="1630928"]');
              if (mgidWidget1) {
                mgidWidget1.remove();
              }
              const bottom_center_ad = document.getElementById("bottom_center_ad");
             if (bottom_center_ad) {
               bottom_center_ad.remove();
             }
             const ad_in_between_art = document.getElementById("ad_in_between_art");
             if (ad_in_between_art) {
              ad_in_between_art.remove();
             }
              window.addEventListener("scroll", function onScroll() {
              const momagicScript = document.getElementById("interactive_js_adcode");
              if (momagicScript) {
                momagicScript.remove();
              const vuukleQuiz = document.getElementById("vuukle-quiz-container");
                        if (vuukleQuiz) {
                          vuukleQuiz.remove();
                        }
                        if (vuukle_script) {
                    vuukle_script.remove();
                  }
                window.removeEventListener("scroll", onScroll);
              }
            });
          }
       });
        this.getHoroscope();
      // this.getAds();
        this.getRightbar();
        this.getGoogleAds();
        this.getCricketUpdate();
  }

  
  render() {
    var showAds = 1;
    var checkonce = 1;
   const FilterHtmlContent = (item) => {
      if (item.Type == "Video") {
        return (
          <div>
            {" "}
            <iframe
              className="Youtube-iframe"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              src={item.EmbedUrl}
            ></iframe>
          </div>
        );
      }
      if (item.Type == "Image") {
        //let alt = 'webdunia';

      //  if(window.location.pathname == "/article/other-news/paytm-goes-public-as-indian-unicorns-draw-huge-investor-interest-121082300007_1.html")
      //  alt = '10Cric Payment Methods';

       // if()
       if(item.Path == "https://nonprod-media.webdunia.com/public_html/_media/en/img/article/2023-02/09/full/1675929248-5589.jpg")
          {
            return(
              <>
              </>
            )
          }
          else{
        return (
          <>
          <div className="arti_img">
            <img src={( item.Path == "https://nonprod-media.webdunia.com/public_html/_media/en/img/article/2023-02/09/full/1675929248-5589.jpg" ? ''  :  ImageConvertionDefault(item.Path))      } alt={ (typeof item.alttext != "undefined" ? item.alttext  : "webdunia")} className="imgCont" />
          </div>

          
          {(() => {
                if (checkonce == 1) {
                  return (
                    <Suspense fallback={renderLoader()}>   
            <div className="ad_in_between_art" id="ad_in_between_art">
            <ROS_Left_336_280 AdData = {this.state.googleAds} showAds = {showAds}/> 
            </div>
            </Suspense>
                  )
                }
              })()}
          </>

        );
            }
      }
      checkonce = 0 ;
      if (item.Type == "AdSpace" && item.Index == 1 ) {
        return (
          <>  
        <div data-type="_mgwidget" data-widget-id="1630949"> 
        <script src="/js/adgebra_middle.js"></script>
        </div> 
        <br/>
         <div id="aniview_player" style={{ margin: '0 auto ', marginBottom : '20px' , marginTop : '20px' , maxWidth :'450px' , clear : 'both'}}></div>
          </>
        );
      }
      if (item.Type == "FreeHtml") {
        var Html = item.Html;
        if(Html.match("version will cost you Rs 66,000"))
        {
          Html += '<div className="arti_img"><img src="https://nonprod-media.webdunia.com/public_html/_media/en/img/article/2023-02/09/full/1675929248-5589.jpg" alt="webdunia" class="imgCont" /></div>';
        }
       
        var Html_Content = Html.replace('<div style="text-align: justify;"><div>', "<br />");
        var Html_Content = Html_Content.replace('<div style="text-align: justify;">&nbsp;</div>', "<br />");
       
        return ReactHtmlParser(Html_Content);
      }
    }
    //console.log("Rightbar",this.state.googleAds);
    const renderLoader = () => <div className="loading_screen"></div>;
    let Articledata = this.state.Articledata;
    let ArticledataFull = Articledata;
    let PagelistData = ArticledataFull.filter((x) => x.Type === "PageList");
    let mustReadData = PagelistData.slice(0, 1);
    let relatedNews = PagelistData.slice(1, 2);
    let ArticleContent = ArticledataFull.filter((x) => x.Type === "Article");
    let ArticleContentCC = ArticleContent;
    // const SearchTags = [];
    const ArticledataFullItems = ArticleContentCC.map((item, i) => {
      const propertyName = [item.RelatedArticles];
      return (
        <div key={i}>
          <div className="article_sticky_sect sticky-top">
        
          <div className="auth_thumb" ><img src={item.AuthorThumbnail} /></div>
            <div className="arti_written"> 
              <span>Written By</span> {item.AuthorName || "N.A."}
             
            </div>

            <div className="arti_date">
              <span>Last Updated:</span> {item.DateTime}
            </div>
            <div className="arti_social_block">
              <ul>
                <li>
                  <a
                    href={
                      "https://www.facebook.com/share.php?u=" +
                      item.Url +
                      "&utm_source=facebook&utm_medium=social&utm_campaign=fbshare"
                    }
                    title={item.Title}
                    target="_blank"
                    className="art_fb_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://twitter.com/intent/tweet?status=" +
                      item.Title +
                      "+&url=" +
                      item.Url +
                      "&utm_source=twitter&utm_medium=social&utm_campaign=twshare"
                    }
                    className="art_tw_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://api.whatsapp.com/send?text=" +
                      item.Title +
                      " / " +
                      item.Url +
                      "&utm_source=whatsapp&utm_medium=social&utm_campaign=washare"
                    }
                    className="art_whapp_icon"
                  ></a>
                </li>
                <li>
                  {/* <a href="" className="art_email_icon"></a> */}
                </li>
              </ul>
            </div>
            {/* { const array = [item.RelatedArticles] ; } */}
            {
                (() => {
                  if (propertyName[0] != null ) {
                  return (
                   propertyName.map((item, i) => (
                <div className="next_article_block" key={i}>
                  <h3>Next Article</h3>
                  <ul>
                    {item.Items.map((item, i) => (
                      <li key={i}>
                        <a href={item.Url}>{item.Title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
                 
                  )
                }})()}
          </div>
          <div className="article_content">
            <div className="article_in_content">
              <div className="article_title ">
                <h1>{item.Title}</h1>
              </div>

              {item.Url.includes("125030500020_1") && (
                <div className="article_sub_heading">
                  <h2>{item.SubHeading}</h2>
                </div>
              )}
              {(() => {
                if (this.state.IsVideoArticle == 'yes' && typeof this.state.VideoArticleUrl != 'undefined') {
                 let regex = /(?<=src=").*?(?=[\*"])/;
                 var src =  this.state.VideoArticleUrl.match(regex);
                  //var src = $("iframe").attr("src").split('?')[0];
                 // console.log("src",src)
                  return (
                    <div className="container" style = {{paddingBottom : "15px"}}> 
                    <LiteYouTubeEmbed 
              style = {{width : "320px", height : "270px" ,padding : "5px"}}
              id={src[0].split("/").pop()}
            title="youtube embed"
            poster="mqdefault"
            webp = {true}
    />
                    {/* {ReactHtmlParser(this.state.VideoArticleUrl)} */}
                    <br />
                    </div>
                  )
                }
              })()} 
              {item.Contents.map((item, i) => {
                if (item.Type == "KeywordCloud") {
                  this.SearchTags = item.Pages;
                }
                return (
                  <div key={i}>
                    {FilterHtmlContent(item)}
                  </div>
                );
              })}
            </div>
            <div className="readmore_tags">
              <ul className="readm_tags_list">
                <li>
                  <span>Read More :</span>
                </li>
                {this.SearchTags.map((item, i) => (
                  <li key={i}>
                    <a href={item.Url}>{item.Title}</a>
                  </li>
                ))}
              </ul>
            </div>
           
           
            <div>
            
        </div>
            {/* <div> <Article_Middle_728_90 AdsData={this.state.AdUnits}/></div> */}
           
          </div>
        </div>
      );
    });
   //console.log("ddsadnsad",this.state.Domainurl);
    return (
      <>
       <div className="full_ads_block ">
                 <Suspense fallback={renderLoader()}>
               <ROS_Top_Center_728_90 AdData= {this.state.googleAds} showAds = {showAds} />
             </Suspense>
             </div>
      <div className="article_detail">
        <Helmet>
        <script src="https://cnt.trvdp.com/js/1090/4635.js"></script>
        <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
        <script async src="https://www.instagram.com/embed.js"></script>
        <script async id="AV611661025c3adf4d362a1e70" type="text/javascript" src="https://tg1.aniview.com/api/adserver/spt?AV_TAGID=611661025c3adf4d362a1e70&AV_PUBLISHERID=6072c4c6f50b1d56f001c8ad"></script>
        </Helmet>
       
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="aritcle_container">{ArticledataFullItems}</div>
              <div id="ad_video_player"></div>
              <br/>
              <div className="article_after_seciton">
              <div className="full_ads_block" id="bottom_center_ad">
                 <Suspense fallback={renderLoader()}>
               <Ros_bottom_center_728_90 AdData= {this.state.googleAds} showAds = {showAds} />
             </Suspense>
             </div>
                <RelatedArticle dataFromParent={relatedNews} />
                <br />
             
                <Article_bottom_text  />
                
              </div>
            <Helmet>
            <script src="/js/vuukle.js" id="vuukle_script"></script>
             </Helmet>
             <div id='vuukle-comments'></div>
            </div> 
            <div className="col right_side_bar">
           <Rightbar Rightbar = {this.state.Rightbar} googleAds = {this.state.googleAds} showAds = {showAds} CricketData = {this.state.CricketData}
           />
           </div>
          </div>
        </div>
      </div>
      <Helmet>
      <script src= "/js/banner.js"  ></script>
      </Helmet>
      </>
    );
  }
}
